import { render } from "./PopupController.vue?vue&type=template&id=ae30f5aa"
import script from "./PopupController.vue?vue&type=script&lang=js"
export * from "./PopupController.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__